module.exports = __webpack_public_path__ + "img/C.51d502e3.png";